import React from "react";
import { useNavigate } from "react-router-dom";
import { fullName } from "../../lib/format";
import { CustomIcon } from "../shared/CustomIcon";
import MyAttendancePanel from "./MyAttendancePanel";

// =============================================================
// MyAttendancePage — dedicated full-page personalised view.
// Delegates all rendering to MyAttendancePanel (also used inside
// the Attendance page as a tab).
// =============================================================

export default function MyAttendancePage({ currentUser, members, attendance, services, events, isPastor, isTeamMember }) {
  const navigate = useNavigate();
  const meMember = (members || []).find(m => m.id === currentUser?.memberId);

  return (
    <div data-testid="my-attendance-page" style={{ padding: "20px clamp(16px,4vw,32px)" }}>
      <div style={{ maxWidth: 820, margin: "0 auto" }}>
        <button
          onClick={() => navigate(-1)}
          data-testid="my-attendance-back"
          style={{ background: "transparent", border: "1px solid color-mix(in srgb, var(--kc-accent) 35%, transparent)", color: "var(--kc-accent)", padding: "6px 12px", borderRadius: 8, cursor: "pointer", fontSize: 12, marginBottom: 16 }}
        >← Back</button>

        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <CustomIcon name="clipboard" size={26} />
          <div style={{ fontFamily: "'Cinzel',serif", fontSize: 22, fontWeight: 700, color: "var(--kc-accent)", letterSpacing: "0.10em", textTransform: "uppercase" }}>
            My Attendance
          </div>
        </div>
        {meMember && (
          <div style={{ fontSize: 12, color: "var(--kc-sub)", marginBottom: 18, fontFamily: "'Montserrat',sans-serif" }}>
            Linked to <strong style={{ color: "#FFF" }}>{fullName(meMember)}</strong>
          </div>
        )}

        <MyAttendancePanel
          currentUser={currentUser}
          members={members}
          attendance={attendance}
          services={services}
          events={events}
          isPastor={isPastor}
          isTeamMember={isTeamMember}
          navigate={navigate}
          defaultPeriod="month"
        />
      </div>
    </div>
  );
}
